import * as React from 'react'
import clsx from 'clsx'
import { useForkRef, useEnhancedEffect, capitalize } from '@applift/factor'
import { GridRootContainerRef } from '../../models/gridRootContainerRef'
import { useGridApiContext } from '../../hooks/utils/useGridApiContext'
import { useGridRootProps } from '../../hooks/utils/useGridRootProps'
import style from '../../style'

/* eslint-disable-next-line */
export interface GridRootProps extends React.HTMLAttributes<HTMLDivElement> {}

export const GridRoot = React.forwardRef<HTMLDivElement, GridRootProps>(
  function GridRoot(props, ref) {
    const { classes, autoHeight, density } = useGridRootProps()
    const { children, ...others } = props
    const apiRef = useGridApiContext()

    const rootContainerRef: GridRootContainerRef =
      React.useRef<HTMLDivElement>(null)
    const handleRef = useForkRef(rootContainerRef, ref)

    apiRef.current.rootElementRef = rootContainerRef

    // Our implementation of <NoSsr />
    const [mountedState, setMountedState] = React.useState(false)
    useEnhancedEffect(() => {
      setMountedState(true)
    }, [])

    useEnhancedEffect(() => {
      if (mountedState) {
        apiRef.current.unstable_updateGridDimensionsRef()
      }
    }, [apiRef, mountedState])

    if (!mountedState) {
      return null
    }

    return (
      <div
        {...others}
        className={clsx(
          [style.root, classes?.root],
          autoHeight && [style.autoHeight, classes?.autoHeight],
          density && [
            // @ts-ignore
            style[`root--density${capitalize(density)}`],
            // @ts-ignore
            classes?.[`root--density${capitalize(density)}`],
          ]
        )}
        ref={handleRef}
        role="grid"
      >
        {children}
      </div>
    )
  }
)
